export default "__VITE_ASSET__BVJbBeZ6__"